// This file is generated by a script. Do not edit this file directly.
import React from "react";
import { categoricalColors } from "../../theme/colors";
var isCategoricalColor = function isCategoricalColor(color) {
  return Object.keys(categoricalColors).includes(color);
};
export var ChipColorDisplay = function ChipColorDisplay(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    className: 'cop-h-2 cop-min-h-2 cop-w-2 cop-min-w-2 cop-rounded-full',
    style: {
      backgroundColor: isCategoricalColor(color) ? "var(--".concat(color, "-primary)") : color
    }
  });
};
